import { createResource } from 'solid-js'
import { handleGetMessageMeta } from './resources'

export function useMessageMeta() {
	const [messageMetaResource] = createResource(handleGetMessageMeta)

	return {
		messageMetaResource,
	}
}
